<template>
    <div class="fixed-scroller">
        <div class="v-alert w-800" style="position: absolute;">
            <header><p>Competition {{ ad.title }}</p><div class="x" @click="emit('exit')"></div></header>
            <div class='stats-comps'>
                <div class="ads-spins">
                    <p>Unique Spins: <span>{{ Object.keys(ad.unique || {}).length }}</span></p>
                    <div class="list-box">
                        <div v-for="customer_id in Object.keys(ad.unique || {})" class="list-item">
                            <p class="td-ulb ellip" @click="getCustomer(customer_id)">{{ getName(customer_id) }}</p>
                            <p class="ta-r">{{ ad.unique[customer_id] }}</p>
                        </div>
                    </div>
                </div>
                <div class="entry-dates" style="position: relative;">
                    <p style="text-align: right;margin-right: 40px;">Entries: <span>{{ entries.length }}</span></p>
                    <input @keyup="searchEntries($event)" style="position: absolute;width: 260px;margin:0px;top: 0px;left: 0px;padding: 1px;margin: 1px 4px" placeholder="Search" />
                    <div class="list-box">
                        <div v-for="entry in entries" class="list-item" v-if="entry.show">
                            <p class="td-ulb">{{ entry.name }}</p>
                            <p>{{ entry.date > 0 && format(entry.date,'dd/MM/yy HH:mm') }}</p>
                            <p>{{ entry.code }}</p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="btns">
                <p class="btn" @click="download">download</p>
            </div>
        </div>
        <component v-if="component" :is="component" @emit="emit" :item="cItem" style="z-index: 10;"/>
    </div>
</template>

<script>

import { format } from 'date-fns'
import WebSoc from '../utils/WebSoc.js';
import EditMember from '../components/editMember.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'stats-comps',
    props: ['item'],
    components: {
        EditMember
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        db () { return this.$store.state.client_id+'-customers' }
    },
    data () {
        return {
            component: '',
            cItem: false,
            format,
            customers: [],
            entries: [],
            spins: [],
            ad: {}
        }
    },
    mounted () {
        this.ad = this.item;
        this.makeDitems(this.ad.dRotate).then(items => {
            this.spins = items;
            console.log('spins',this.spins);
        });
        var customer_ids = Object.keys(this.ad.unique || {}).map(customer_id => { return { _id: customer_id }});

        customer_ids.length > 0 && WebSoc.SEND('search', { DB: this.db, find: { $or: customer_ids }, project: { name: 1 } },customers => {
            this.customers = customers;
        });

        WebSoc.SEND('search',{ DB: this.client_id+'-comps', find: { ad_id: this.ad._id }},entries => {
            entries.forEach(e => e.show = true);
            this.entries = entries;
        });        
    },
    methods: {
        searchEntries ( e ) {
            var text = new RegExp(e.target.value.split('').join(' *'),'i');
            console.log('text',text);
            this.entries.forEach(e => {
                e.show = text.test(e.name+e.code);
                console.log(e.show,e);
            })
        },
        download () {
            this.downloadCSV({
                fileName: this.entries[0].aTitle+' - '+format(Date.now(),'dd/MM/yy HH:mm')+'.csv',
                csv: [['Campaign','Competition','Memmber','Entry Code','Entry Date'].join(',')].concat(this.entries.map(e => [e.sTitle,e.aTitle,e.name,e.code,format(e.date,'dd/MM/yy HH:mm')].join(','))).join('\n')
            })
            //var csv = [['Campaign','Competition','Memmber','Entry Code','Entry Date'].join(',')].concat(this.entries.map(e => [e.sTitle,e.aTitle,e.name,e.code,format(e.date,'dd/MM/yy HH:mm')].join(','))).join('\n');
            //var fileName = this.entries[0].aTitle+' - '+format(Date.now(),'dd/MM/yy HH:mm')+'.csv';
            //var blob = URL.createObjectURL(new Blob([csv],{ type: 'text/csv' }));
            //this.downloadBlob({ fileName, blob })
        },
        getCustomer ( customer_id ) {
            WebSoc.SEND('get',{ DB: this.db, _id: customer_id },customer => {
                this.item = customer;
                this.component = 'EditMember';
                console.log('customer',customer);
            });
        },
        getName ( customer_id ) {
            var customer = this.customers.find(c => c._id == customer_id);
            return customer ? customer.name : 'no name';
        },
        emit( action ) {
            if ( action.t == 'edit-member' && action.action == 'exit' ) {
                this.item = false;
                this.component = '';
                return;
            }
            this.$emit('emit',{ t: 'stats-ads', item: this.ad, action });
        },
        ...mapMutations([
            'downloadBlob',
            'downloadCSV'
        ]),
        ...mapActions([
            'makeDitems'
        ])
    }
}

</script>

<style scopped lang="scss">
.stats-comps {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-height: 300px;
    > div {
        border-right: 1px solid #c0c0c0;
        &:last-child { border-right: 0px }

        > p {
            text-align: center;
            line-height: 30px;
            margin-bottom: -6px;
        }
    }
    > div {
        .list-box {
            margin: 5px;
            border:1px solid #c0c0c0;
            overflow-y: scroll;
            position: relative;
            max-height: 260px;
            /* &:nth-child(odd) { background-color: rgba(100,100,100,0.3); } */
            > div {
                padding: 5px 5px;
            }
        }
    }
    .ads-spins {
        .list-item {
            display: grid;
            grid-template-columns: 140px 40px;
        }
    }
    .entry-dates { 
        .list-item {
            display: grid;
            grid-template-columns: 140px 120px 120px; 
        }      
    }
}
</style>